import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationFacade } from '@core/facades/notification.facade';
import { AuthService } from '@core/services/auth.service';
import { ErrorDialogService } from '@core/services/error-dialog.service';
import { Store } from '@ngxs/store';
import { Observable, catchError, throwError } from 'rxjs';

/**
 * Set on a request whose caller reports failures itself, so the same error is not
 * announced twice. Only the toast is suppressed - session handling below (the
 * redirect on an expired token) still runs.
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export const ErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  let toast = inject(NotificationFacade);
  let router = inject(Router);
  let store = inject(Store);
  let authService = inject(AuthService);

  const silent = req.context.get(SKIP_ERROR_TOAST);
  const notify = {
    error: (message: string) => (silent ? null : toast.error(message)),
    info: (message: string) => (silent ? null : toast.info(message)),
  };

  return next(req).pipe(
    // tap((res: HttpHeaderResponse)=>),
    catchError((err: HttpErrorResponse) => {
      // console.log(err);
      if (err) {
        switch (err.status) {
          case 400:
            notify.error(err?.error?.message || err?.message || err?.statusText);
            break;
          case 401:
            router.navigateByUrl(`/auth/login`);
            notify.info('Your session has expired, please log in again');
            break;
          case 403:
            if (authService.tokenIsExpired()) {
              authService.storeReturnUrl()
              router.navigateByUrl(`/auth/login`);
              notify.error(
                'Your session has expired.'
              );
            } else {
              notify.error(
                'You are not authorized to access this resource.'
              );
            }
            break;
          case 500:
            notify.error('Internal Server Error, please try again');
            break;
          case 502:
            notify.error('Internal Server Error, please try again');
            break;
          default:
            notify.error('Unexpected Error');
            err ? console.error('default: ', err.message) : null;
            break;
        }
      }
      return throwError(() => err);
    })

  );
};
